<template>
  <div v-if="!isLoadingInit">
    <b-row class="justify-content-center">
      <b-col cols="2" class="mb-5 mb-sm-0">
        <label>{{ $t("general.N°_de_votant") }}</label>
        <b-input :value="buildingOwner.number" @input="updateBuildingOwner('number', $event)" />
      </b-col>
      <b-col cols="10">
        <b-row class="justify-content-center">
          <b-col>
            <label>{{ $t("general.Numéros_de_lots") }}</label>
          </b-col>
        </b-row>
        <b-row class="justify-content-center">
          <b-col cols="9" class="custom-select-autocomplete p-0">
            <b-input
              ref="v-input"
              class="custom-select-autocomplete-input"
              autocomplete="off"
              :value="defaultBuildingLot.name"
              @input="input"
              @focus="focus"
              @blur="blur"
              @keyup.enter="input"
            />
            <v-select
              ref="v-select"
              class="custom-select-autocomplete-select"
              :options="unattachedBuildingLots()"
              label="name"
              @input="select($event)"
            >
              <span slot="no-options">
                {{ $t("general.select_with_input_no_option") }}
              </span>
            </v-select>
          </b-col>
          <b-col cols="3">
            <b-button
              id="button-create-lot"
              :disabled="defaultBuildingLot.name.length == 0 || checkIfNameIsTaken()"
              class="button btn-blue btn-filter ml-1"
              @click="addBuildingOwnerHasBuildingLot"
            >
              <font-awesome-icon class="agv-button-icon" icon="plus" />
              <span>{{ $t("general.New_lot") }}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mx-auto d-inline-flex flex-wrap my-3">
            <b-card
              v-for="(buildingLot, index) in sortedBuildingLots"
              :key="index"
              class="my-1 mx-1"
              body-class="py-1 px-2 text-nowrap"
            >
              <strong v-if="buildingLot.building_lot_name" class="mr-1">{{
                buildingLot.building_lot_name
              }}</strong>
              <strong v-else class="mr-1">{{ buildingLot.name }}</strong>
              <font-awesome-icon
                style="cursor: pointer;"
                icon="times-circle"
                @click="removeBuildingLot(index, buildingLot.id)"
              />
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
  <appLoader v-else />
</template>

<script>
import BuildingLotORM from "@/store/orm-axios/models/BuildingLot";
import BuildingLotMW from "@/middlewares/BuildingLot";
var uuid = require("uuid");

export default {
  props: {
    buildingOwner: {
      type: Object,
      default: () => {
        return {};
      },
    },
    buildingId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isLoadingInit: true,
      defaultBuildingLot: {
        agency_id: Number(localStorage.getItem("agencyId")),
        name: "",
        building_id: this.buildingId,
      },
      apiBuildingLots: [],
      buildingOwnerHasBuildingLots: [],
      showTooltipButtonCreateLot: false,
      buildingLots: [],
    };
  },
  computed: {
    computedBuildingLots() {
      let buildingLots = BuildingLotORM.query()
        .where("agency_id", this.agencyId)
        .where("building_id", this.buildingId)
        .with("building_owner_building_lots")
        .get();
      return buildingLots;
    },
    sortedBuildingLots() {
      return this.sortArr(this.buildingOwner.building_lots);
    },
  },
  async created() {
    await BuildingLotMW.FETCH(this.buildingId);

    this.buildingLots = this.computedBuildingLots;
    this.isLoadingInit = false;
    if (this.buildingOwner.building_lots.length > 0) {
      this.apiBuildingLots = this.sortArr(this.buildingOwner.building_lots);
    }
    if (this.buildingOwner.building_owner_building_lots) {
      this.buildingOwnerHasBuildingLots = this.buildingOwner.building_owner_building_lots;
    }
    // console.log("step 2 buildingOwner: ", this.buildingOwner);
  },
  methods: {
    updateBuildingOwner(key, value) {
      this.$emit("updateBuildingOwner", key, value);
    },
    input(e) {
      // NOTE: If Enter key is pressed
      if (e.key && e.key == "Enter") {
        e = e.target.value;

        this.defaultBuildingLot.name = e;
        this.$refs["v-select"].search = e;
        this.$refs["v-select"].open = false;
        this.addBuildingOwnerHasBuildingLot(e);

        return;
      }

      this.defaultBuildingLot.name = e;
      this.$refs["v-select"].search = e;
    },
    focus(e) {
      // console.log(e);
      this.$refs["v-select"].open = true;
    },
    blur(e) {
      // console.log(e);
      this.$refs["v-select"].open = false;
    },
    select(e) {
      // console.log(e);
      this.addBuildingOwnerHasBuildingLot(e);
    },
    addBuildingOwnerHasBuildingLot(buildingLot) {
      // console.log("buildingLot: ", buildingLot);
      let buildingLotId = uuid.v4();
      let buildingLotName = this.defaultBuildingLot.name;
      let buildingOwnerHasBuildingLotId = uuid.v4();

      if (buildingLot.building_owner_building_lots) {
        buildingLotId = buildingLot.id;
        buildingLotName = buildingLot.name;
      }
      this.apiBuildingLots.push({
        id: buildingLotId,
        name: buildingLotName,
        building_owner_building_lots: [{ id: buildingOwnerHasBuildingLotId }],
      });
      this.buildingOwnerHasBuildingLots.push({
        id: buildingOwnerHasBuildingLotId,
        building_lot_id: buildingLotId,
        building_lot_name: buildingLotName,
      });
      // console.log(this.apiBuildingLots);
      this.apiBuildingLots = this.sortArr(this.apiBuildingLots);
      this.updateBuildingOwner("building_lots", this.apiBuildingLots);
      this.updateBuildingOwner("building_owner_building_lots", this.buildingOwnerHasBuildingLots);

      // Clear input
      this.defaultBuildingLot.name = "";
      this.unattachedBuildingLots();
    },
    removeBuildingLot(index, buildingLotId) {
      this.apiBuildingLots = this.$_.reject(this.apiBuildingLots, function (item) {
        return item.id == buildingLotId;
      });
      let indexToBeChanged = this.$_.findIndex(this.buildingOwnerHasBuildingLots, item => {
        return item.building_lot_id == buildingLotId;
      });
      this.buildingOwnerHasBuildingLots[indexToBeChanged]["isDeleted"] = true;
      this.buildingOwner.building_lots.splice(index, 1);
      this.buildingOwner.building_lots = this.$_.reject(this.buildingOwner.building_lots, function (
        item
      ) {
        return item.id == buildingLotId;
      });
      let indexBLot = this.$_.findIndex(this.buildingLots, item => {
        return item.id == buildingLotId;
      });
      this.buildingLots[indexBLot]["isDeleted"] = true;
      this.unattachedBuildingLots();
    },
    checkIfNameIsTaken() {
      var nameIsTaken;
      nameIsTaken = this.$_.find(this.buildingOwner.building_lots, lot => {
        return lot.name == this.defaultBuildingLot.name;
      });
      if (nameIsTaken) this.showTooltipButtonCreateLot = true;
      else this.showTooltipButtonCreateLot = false;
      return !!nameIsTaken;
    },
    unattachedBuildingLots() {
      var self = this;
      var buildingLots = JSON.parse(JSON.stringify(this.buildingLots));
      let unattachedBuildingLots = [];
      buildingLots.forEach(buildingLot => {
        if (
          buildingLot.building_owner_building_lots &&
          buildingLot.building_owner_building_lots.length > 0 &&
          buildingLot.building_owner_building_lots[0].building_owner_id == this.buildingOwner.id
        ) {
          // Check if buildingLot is already selected
          let findElement = self.$_.find(self.buildingOwnerHasBuildingLots, item => {
            if (
              item.id == buildingLot.building_owner_building_lots[0].id &&
              (item.isDeleted == undefined || item.isDeleted)
            ) {
              return item;
            }
          });
          // If buildingLot cannot be found add it to unattachedBuildingLots
          if (findElement == undefined) {
            unattachedBuildingLots.push(buildingLot);
          }
        }
      });
      return unattachedBuildingLots;
    },
    sortArr(arr) {
      // NOTE: Filter and sort only the strings that are numbers
      let numArr = arr
        .filter(el => el.name != "" && !isNaN(el.name))
        .sort((a, b) => Number(a.name) - Number(b.name));

      // NOTE: Filter and sort only the strings
      let strArr = arr.filter(el => isNaN(el.name)).sort();

      return numArr.concat(strArr);
    },
  },
};
</script>
